<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[70%] rounded-lg px-7 py-8 mt-8">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <div class="flex justify-center">
                    <h2 class="text-4xl font-semibold text-center text-black bg-[#e5e5e5] px-16 py-6 border-2 mt-44 mb-20 border-black inline-block rounded-xl">ATTESTATION DE CONGES</h2>
                </div>

                <p class="text-gray-700 mb-10 text-2xl">
                    Nous soussignés, International University of Grand-Bassam (IUGB), BP 564 Grand-Bassam, Côte d’Ivoire attestons que <span class="font-bold">{{ nom ?? "TITLE NAME" }}</span>, <span class="font-bold">{{ poste ?? "POSITION" }}</span> , sera en congés annuels du LEAVE PERIOD inclus.
                </p>

                <p class="mb-10 text-gray-700 text-2xl">
                    Elle/il reprendra normalement le service le <span class="font-bold">{{ reprise ?? "RESUMPTION DATE" }}</span> aux horaires habituels.
                </p>

                <p class="mb-16 text-gray-700 text-2xl">
                    En foi de quoi, nous lui délivrons la présente attestation pour soutenir sa demande de visa auprès de l’ambassade de <span class="font-bold">{{ contry ?? "COUNTRY" }}</span> en Côte d’Ivoire.
                </p>

                <div class="text-right text-2xl">
                    <p class="text-gray-700 mb-32">Fait à Abidjan le <span class="font-bold">DATE</span></p>
                    <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                </div>
                <div class="flex justify-end">
                    <div class="w-[300px] h-[150px] rounded-xl border border-dashed mt-5 flex flex-col items-center justify-center p-3">
                        <p v-if="!signature" class="font-extralight text-black">Pas de signature</p>
                        <img v-else :src="getPath" :alt="signature" class="h-full object-contain">
                    </div>
                </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "AttestCongeValid",
    components: {Loader2},
    data() {
        return {
            id:"",
            asSend: false,
            nom: null,
            poste: null,
            reprise: null,
            contry: null,
            signature: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
        this.signature = localStorage.getItem("signature") ?? undefined;
    },
    computed:{
        getPath(){
            return `https://backend-ehr.iugb-ci.com/public/image/${this.signature}`;
        }
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.poste= JSON.parse(data.data["data"]["content"]).poste;
                    this.reprise= JSON.parse(data.data["data"]["content"]).reprise;
                    this.contry= JSON.parse(data.data["data"]["content"]).contry;
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            if(!this.signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : this.signature
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>